var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHeadsetError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7748 24.33H28.0766V14.4552H22.7748V3.67578H8.30176V14.4552H3V24.3384H10.8144V6.18847H20.2538V24.33",
    fill: "#2E283C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 4.5,
    r: 4.5,
    fill: "#E9226A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9688 5.51522H25.0168L24.8168 1.69922H26.1688L25.9688 5.51522ZM24.8008 6.85122C24.8008 6.60589 24.8674 6.43522 25.0008 6.33922C25.1341 6.23789 25.2968 6.18722 25.4888 6.18722C25.6754 6.18722 25.8354 6.23789 25.9688 6.33922C26.1021 6.43522 26.1688 6.60589 26.1688 6.85122C26.1688 7.08589 26.1021 7.25655 25.9688 7.36322C25.8354 7.46455 25.6754 7.51522 25.4888 7.51522C25.2968 7.51522 25.1341 7.46455 25.0008 7.36322C24.8674 7.25655 24.8008 7.08589 24.8008 6.85122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeadsetError);
export default __webpack_public_path__ + "static/media/ic_headset_error.20c6b8794e9793dc983dc21cdfb8270b.svg";
export { ForwardRef as ReactComponent };